import { AppPlatform } from "app/types";

/**
 * アプリ内の「Apple でサインイン」ボタン（ネイティブへ postMessage する自前のもの）を
 * 出すかを判定する。
 *
 * ⚠️ Apple サインインが使えるかの判定ではない。ブラウザは Apple 公式の
 *    `id="appleid-signin"` ボタン（AppleID.auth）を使うので、ここが false でも
 *    SSO.tsx の次の分岐でそちらが出る。
 *
 * - iOS: 常に true（ネイティブ API が最初からある）
 * - Android: buildVersion 98 以上。ブラウザ経由の Web フローを載せた版から
 * - Amazon: false（未対応）
 * - ブラウザ: false（アプリ内ではないため。Apple 公式ボタンへ回る）
 */
export const isNativeAppleSignInSupported = (): boolean => {
  if (!window.ReactNativeWebView) return false;

  const platform = window.kidsAppPlatform;
  if (platform === AppPlatform.iOS) {
    return true;
  }
  if (platform === AppPlatform.Android) {
    return Number(window.kidsBuildVersion) >= 98;
  }
  return false;
};
